import { JwtAxios } from '@/packaging';

export const vitapayApi = {
  // ============ Vitapay 회원 API ============

  // 회원 등록 상태 확인
  async getMemberStatus() {
    const res = await JwtAxios.get('/Vitapay/GetMemberStatus');
    return res;
  },

  // 회원 ID 중복 체크
  async checkId(memid) {
    const res = await JwtAxios.get(`/Vitapay/CheckId/${memid}`);
    return res;
  },

  // 회원 등록
  async register(body) {
    const res = await JwtAxios.post('/Vitapay/Register', body);
    return res;
  },

  // 기존 회원 연동
  async linkExistingMember(body) {
    const res = await JwtAxios.post('/Vitapay/LinkExistingMember', body);
    return res;
  },

  // 자동 로그인 URL 발급
  async getAutoLoginUrl() {
    const res = await JwtAxios.get('/Vitapay/GetAutoLoginUrl');
    return res;
  },

  // ============ Vitapay 마켓 API ============

  // 마켓 코드 목록 조회
  async getMarketCodes() {
    const res = await JwtAxios.get('/Vitapay/GetMarketCodes');
    return res;
  },

  // 마켓 정보 등록
  async registerMarket(body) {
    const res = await JwtAxios.post('/Vitapay/RegisterMarket', body);
    return res;
  },

  // 마켓 비밀번호 수정
  async updateMarket(body) {
    const res = await JwtAxios.put('/Vitapay/UpdateMarket', body);
    return res;
  },

  // 마켓 정보 삭제
  async deleteMarket(body) {
    const res = await JwtAxios.delete('/Vitapay/DeleteMarket', { data: body });
    return res;
  },

  // ============ 기존 API (내부용) ============

  // 선정산 시뮬레이션 (지난달 매출 리포트 기반)
  async getSimulation() {
    const res = await JwtAxios.get('/Payment/GetVitapaySimulation');
    return res;
  },

  // 마켓 목록 조회 (환경설정->마켓설정의 마켓들)
  async getMarketList() {
    const res = await JwtAxios.get('/Payment/GetMarketList');
    return res;
  },

  // 선정산 신청 (내부 저장용)
  async applyVitapay(body) {
    const res = await JwtAxios.post('/Payment/ApplyVitapay', body);
    return res;
  },

  // 선정산 신청 결과 조회
  async getApplicationResult() {
    const res = await JwtAxios.get('/Payment/GetVitapayApplicationResult');
    return res;
  },

  // 오픈마켓 정산내역 조회
  async getOpenmarketSettlement(body) {
    const res = await JwtAxios.post('/Payment/GetOpenmarketSettlement', body);
    return res;
  },

  // 소셜 선정산내역 조회
  async getSocialSettlement(body) {
    const res = await JwtAxios.post('/Payment/GetSocialSettlement', body);
    return res;
  },

  // 일별 차감내역 조회
  async getDailyDeduction(body) {
    const res = await JwtAxios.post('/Payment/GetDailyDeduction', body);
    return res;
  }
};
